export default [
    {
        path: '/settings/roles',
        name: 'roles',
        props: true,
        component: () => import('@/views/settings/roles/index.vue'),
        meta: {
            pageTitle: 'Roles',
            breadcrumb: [
                {
                text: 'Roles',
                active: true,
                },
            ],
        },
    },
    {
        path: '/settings/roles/add',
        name: 'create-roles',
        component: () => import('@/views/settings/roles/create.vue'),
        meta: {
            pageTitle: 'Create Roles',
            breadcrumb: [
                {
                text: 'Roles',
                to: { name: 'roles' },
                },
                {
                text: 'Create Roles',
                active: true,
                },
            ],
        },
    },
    {
        path: '/settings/roles/:id',
        name: 'detail-roles',
        props: true,
        component: () => import('@/views/settings/roles/detail.vue'),
        meta: {
            pageTitle: 'Detail Roles',
            breadcrumb: [
                {
                text: 'Roles',
                to: { name: 'roles' },
                },
                {
                text: 'Detail Roles',
                active: true,
                },
            ],
        },
    },
]